

export interface CompanyLogoProps {
  className?: string;
  fill?: string;
}

export default function CompanyLogo({ className, fill }: CompanyLogoProps) {
  return (
    <svg
      version="1.1"
      id="Réteg_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 235.28 235.28"
      xmlSpace="preserve"
      className={`${className}`}
      fill={`${fill}`}
    >
      <g>
        <path
          style={{ filter: `drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7))` }}
          d="M4.99,74.61c0.72-1.94,0.42-4.01,0.62-6c0.89-8.77,2.85-17.23,6.08-25.43c2.71-6.87,6.38-13.22,11.15-18.8
          c4.04-4.73,8.66-8.9,14.23-11.93c4.41-2.4,8.94-4.31,13.85-5.36c5.65-1.21,11.22-0.96,16.76,0.62c7.86,2.25,14.86,6.36,22.04,10.11
          c6.79,3.56,13.72,6.8,21.46,7.96c10.06,1.51,19.47-0.36,28.58-4.61c6.9-3.22,13.42-7.17,20.33-10.37
          c6.84-3.17,13.98-5.04,21.54-4.34c4.06,0.37,8.02,1.47,11.8,3.13c7.04,3.1,13.28,7.31,18.45,13.04c4.37,4.84,7.9,10.24,10.72,16.12
          c3.46,7.21,5.76,14.75,7.07,22.64c0.93,5.63,1.42,11.25,1.4,16.95c-0.02,4.57,0.11,9.16-0.42,13.7c-0.52,4.51-1.21,8.99-1.98,13.47
          c-1.56,9.04-4.1,17.79-6.85,26.54c-0.61-0.01-0.83-0.56-1.17-0.89c-16.75-16.73-33.47-33.48-50.22-50.2
          c-1.91-1.91-1.46-2.16-3.58,0c-7.01,7.12-14.54,13.71-21.43,21.14c-14.17-14.2-28.23-28.31-42.3-42.41
          c-2.32-2.32-4.7-4.58-6.93-6.98c-1.06-1.14-1.7-1.1-2.78,0c-8.45,8.53-16.97,16.99-25.47,25.48c-17.6,17.61-35.2,35.22-52.8,52.83
          c-0.2,0.2-0.42,0.36-0.69,0.59c-2.99-8.61-5.27-17.3-6.93-26.13c-0.85-4.53-1.33-9.13-1.92-13.7c-0.29-2.22,0.21-4.49-0.61-6.64
          C4.99,81.64,4.99,78.13,4.99,74.61z"
        />
        <path
          style={{ filter: `drop-shadow( 5px 2px 2px rgba(0, 0, 0, .7))` }}
          d="M77.76,232.12c-6.5-2.07-11.03-6.68-15.39-11.63c-5.48-6.23-10.06-13.09-14.41-20.1c-3.38-5.45-6.57-11.01-9.79-16.55
          c-4.26-7.33-8.16-14.86-11.77-22.53c-2.88-6.12-5.59-12.31-8.04-18.62c-0.35-0.9-0.35-1.5,0.43-2.27
          c24.92-24.87,49.81-49.77,74.7-74.66c0.28-0.28,0.58-0.54,1.14-1.07c0,0.9,0,1.52,0,2.13c0,31.93,0,63.87,0.01,95.8
          c0,0.78-0.37,1.89,0.48,2.21c0.68,0.26,1.24-0.72,1.77-1.25c23.49-23.47,46.98-46.95,70.46-70.44c0.27-0.27,0.49-0.61,1.11-0.72
          c0,0.97,0,1.94,0,2.91c0,43.12-0.01,86.25,0.04,129.37c0,1.68-1.06,2.34-2.04,3.19c-2.3,1.98-5.06,3.12-7.83,4.24
          c-1.52,0-3.05,0-4.57,0c-2.24-1.13-4.4-2.24-6.08-4.31c-2.53-3.11-4.23-6.6-5.76-10.24c-2.45-5.85-4.3-11.9-6.13-17.97
          c-1.82-6.07-3.5-12.21-6.4-17.89c-1.4-2.74-2.96-5.41-5.96-6.79c-5.19-2.38-11.85-1.44-15.24,3.48c-2.11,3.06-3.48,6.53-4.72,10.03
          c-1.77,4.98-3.16,10.09-4.72,15.14c-1.67,5.39-3.32,10.8-5.69,15.94c-2.42,5.25-5.28,10.22-11.03,12.62
          C80.81,232.12,79.29,232.12,77.76,232.12z"
        />
      </g>
    </svg>
  );
}
